module.exports = __webpack_public_path__ + "img/logo_tclx.f483bea0.png";